module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Medium.4f995fa4.otf";